import { render, staticRenderFns } from "./PayrollLoans.vue?vue&type=template&id=e05264d0"
import script from "./PayrollLoans.vue?vue&type=script&lang=js"
export * from "./PayrollLoans.vue?vue&type=script&lang=js"
import style0 from "./PayrollLoans.vue?vue&type=style&index=0&id=e05264d0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e05264d0')) {
      api.createRecord('e05264d0', component.options)
    } else {
      api.reload('e05264d0', component.options)
    }
    module.hot.accept("./PayrollLoans.vue?vue&type=template&id=e05264d0", function () {
      api.rerender('e05264d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PayrollLoans.vue"
export default component.exports